/* eslint-disable max-len */
import React from 'react'
import Shimmer from '../../../../../../../components/Shimmer/itemShimmer'
import moment from 'moment';

const MonthTable = ({ data: { records, reportsTotalCount } , isLoading, isNestedTable}) => {

    function capitalizeFirstLetter(str) {
        if (str == undefined) {
            return;
        }
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    return (

        isLoading ?
            <div className=''><Shimmer /> </div> :
            <table aria-label="Outside Table" class="w-full" id="admin-table" style={isNestedTable ? { borderColor: "#e6e8ea" } : {}}>
                <thead>
                    <tr>
                        <th className="w-[25%]" style={isNestedTable ? { backgroundColor: "#e6e8ea" } : {}}>
                            <span >Date
                            </span>
                        </th>
                        <th class="w-[25%]" style={isNestedTable ? { backgroundColor: "#e6e8ea" } : {}}>
                            <span class="flex items-center justify-start">First Half
                            </span>
                        </th>
                        <th class="w-[25%]" style={isNestedTable ? { backgroundColor: "#e6e8ea" } : {}}>
                            <span class="flex items-center justify-start">Second Half
                            </span>
                        </th>

                    </tr>
                    <tr aria-colspan="7" class="h-1"></tr>
                </thead>
                <tbody >
                    {
                        records.map((item, index) => (
                            <tr key={index} className="text-center">
                                <td className="text-start">{moment(item?.date).format('MMM DD, YYYY')}</td>
                                <td className="text-start">{capitalizeFirstLetter(item.first_half)}</td>
                                <td className="text-start">{capitalizeFirstLetter(item.second_half)}</td>
                            </tr>
                        ))
                    }

                </tbody>
                {reportsTotalCount === 0 && (
                    <tbody>
                        <tr>
                            <td style={{ 'line-height': '100px' }} colspan={3} className="no-records-message">
                                {'No matching records found.'}
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>

    )
}
export default MonthTable;   